import React from "react";
import { EntityProfileType } from "@common/types/entity";
import { FiltersTypes } from "@common/types/filters/general";
import { entityTypeV2Labels } from "@common/constants/entity";

interface Props {
    filters: FiltersTypes;
}

export const LegalTypeFilterLabel: React.FC<Props> = ({ filters }) => {
    const { legalTypes } = filters;

    if (!legalTypes || legalTypes.length === 0) {
        return null;
    }

    const labels = legalTypes
        .map((t) => entityTypeV2Labels[t as EntityProfileType])
        .filter(Boolean);

    if (labels.length === 0) {
        return null;
    }

    if (labels.length === 1) {
        return <span>{labels[0]}</span>;
    }

    return <span>{labels.length} legal types</span>;
};
